import parametrosDoSistema from '@/core/apiclient/configuracao/ParametrosSistemaApiClient'
import produto from '@/core/apiclient/ProdutoApiClient'
import itemAdesao from '@/core/apiclient/item-adesao/ItemAdesaoApiClient'
import anuencia from '@/core/apiclient/anuencia/AnuenciaAdesaoApiClient'
import assinaturaAnuencia from '@/core/apiclient/anuencia/assinatura/AssinaturaApiClient'
import documentosAnuencia from '@/core/apiclient/anuencia/documento/DocumentosAnuenciaApiClient'
import ata from '@/core/apiclient/ata/AtaApiClient'
import itens from '@/core/apiclient/itens/ItensApiClient'
import documentos from '@/core/apiclient/documentos/DocumentosApiClient'
import adesaoPublica from '@/core/apiclient/adesao-publica/AdesaoPublicaApiClient'
import documentosPedido from '@/core/apiclient/pedido/documento/DocumentosPedidoApiClient'
import documentosAta from '@/core/apiclient/ata/documento/DocumentosAtaApiClient'
import relatorioControleSaldos from '@/core/apiclient/relatorios/controle-saldos/ControleSaldosApiClient'
import relatorioControleAdesoes from '@/core/apiclient/relatorios/controle-adesoes/ControleAdesoesApiClient'
import tipoDocumento from '@/core/apiclient/tipo-documento/TipoDocumentoApiClient'

export default {
	parametrosDoSistema,
	produto,
	itemAdesao,
	anuencia,
	assinaturaAnuencia,
	documentosAnuencia,
	ata,
	itens,
	documentos,
	adesaoPublica,
	documentosPedido,
	documentosAta,
	relatorioControleSaldos,
	relatorioControleAdesoes,
	tipoDocumento,
}
